import React, { useEffect, useState } from "react"
import * as helpers from "../../helpers/sectionclasses"
import ButtonGroup from "../buttongroup"
import InView from "react-intersection-observer"
import { motion } from "framer-motion"
import Image from "gatsby-image"
import parse from "html-react-parser"
import { deviceType } from 'detect-it';
// import CloudinaryVideo from "./../cloudinaryvideo"
import loadable from "@loadable/component";

const CloudinaryVideo = loadable(() => import("../cloudinaryvideo"), {
  ssr: false, // Disables Server-Side Rendering
});


const IntroPanel = ({ content }) => {

  const isBrowser = () => typeof window !== "undefined";
  const [screenSize, setScreensize] = useState(isBrowser() ? window.innerWidth : '');

  useEffect(() => {
    function handleResize() {
      // Update the state or perform any other actions when the
      // browser is resized
      if(isBrowser()) {
        setScreensize(window.innerWidth);
      }
        
    }

    if(isBrowser()) {
      // Attach the event listener to the window object
      window.addEventListener('resize', handleResize);
    }


    // Remove the event listener when the component unmounts
    return () => {
      if(isBrowser()) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  return (
    <section className={`intro-panel relative ${sectionClasses}`}>
      <div className="container relative z-10">
        <InView threshold={0.25} triggerOnce={true}>
          {({ ref, inView }) => (
            <motion.div
              className="lrg:pt-28"
              ref={ref}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.8 }}
            >
              <div
                className={`${
                  content.alternateLayout
                    ? "flex justify-center lrg:py-20 lrg:px-6"
                    : "lrg:px-6"
                }`}
              >
                {content.label ? (
                  <p className="label mb-2">{content.label}</p>
                ) : (
                  ""
                )}
                <p
                  className={`${
                    content.alternateLayout
                      ? "text-mobmd lrg:text-lg text-center lrg:w-3/4 lrg:px-20"
                      : "text-mobmd lrg:text-xl"
                  }`}
                >
                  {parse(content.title)}
                </p>
                {content.buttons ? (
                  <ButtonGroup classes="pt-14" buttonarray={content.buttons} />
                ) : (
                  ""
                )}
              </div>
            </motion.div>
          )}
        </InView>
      </div>
      <div
        className={`absolute ${
          content.alternateLayout
            ? "w-1/2 top-0 left-0 lrg:top-1/2 lrg:left-1/2 transform lrg:-translate-y-full lrg:-translate-x-full lrg:-ml-28 lrg:mt-8 lrg:w-60"
            : "top-0 left-24 lrg:left-80 w-48 lrg:w-80"
        }`}
      >
        {content.topAsset.type === "video" && content.topAsset?.video && (screenSize > 767 || deviceType !== 'touchOnly') ? (
          <CloudinaryVideo publicUrl={content.topAsset.video} autoPlay={true} />
        ) : (
          ""
        )}
        {content.topAsset.type === "image" &&
        content.topAsset.image?.localFile?.childImageSharp?.fluid ? (
          <Image
            fluid={content.topAsset.image?.localFile?.childImageSharp?.fluid}
          />
        ) : (
          ""
        )}
      </div>
      <div
        className={`absolute ${
          content.alternateLayout
            ? "w-1/3 bottom-0 right-0 lrg:bottom-auto lrg:right-auto lrg:top-1/2 lrg:left-1/2 transform lrg:-translate-y-3/4 lrg:translate-x-full lrg:-ml-32 lrg:w-80 lrg:mt-10"
            : "absolute top-80 right-0 w-48 lrg:w-96"
        }`}
      >
        {content.rightAsset.type === "video" && content.rightAsset?.video && (screenSize > 767 || deviceType !== 'touchOnly') ? (
          <CloudinaryVideo
            publicUrl={content.rightAsset.video}
            autoPlay={true}
          />
        ) : (
          ""
        )}
        {content.rightAsset.type === "image" &&
        content.rightAsset.image?.localFile?.childImageSharp?.fluid ? (
          <Image
            fluid={content.rightAsset.image?.localFile?.childImageSharp?.fluid}
          />
        ) : (
          ""
        )}
      </div>
      <div
        className={`absolute ${
          content.alternateLayout
            ? "w-52 left-0 -bottom-10 lrg:bottom-auto lrg:top-1/2 lrg:left-1/2 transform translate-y-1/2 lrg:-translate-x-full lrg:w-96 lrg:-ml-20 lrg:mt-6"
            : "absolute bottom-0 left-0 lrg:left-auto lrg:right-80 w-1/2 lrg:w-96"
        }`}
      >
        {content.bottomAsset.type === "video" && content.bottomAsset?.video && (screenSize > 767 || deviceType !== 'touchOnly') ? (
          <CloudinaryVideo
            publicUrl={content.bottomAsset.video}
            autoPlay={true}
          />
        ) : (
          ""
        )}
        {content.bottomAsset.type === "image" &&
        content.bottomAsset.image?.localFile?.childImageSharp?.fluid ? (
          <Image
            fluid={content.bottomAsset.image?.localFile?.childImageSharp?.fluid}
          />
        ) : (
          ""
        )}
      </div>
    </section>
  )
}

export default IntroPanel
